// Convierte 'mm:ss' → segundos
export function parseTime(timeString) {
  if (!/^[0-9]+:[0-5][0-9]$/.test(timeString)) return 0;
  const [minutes, seconds] = timeString.split(':').map(Number);
  return minutes * 60 + seconds;
}

// Convierte segundos → 'mm:ss'
export function formatTime(seconds) {
  const sec = Math.round(seconds);
  const min = Math.floor(sec / 60);
  const remainder = sec % 60;
  return `${min}:${remainder < 10 ? '0' : ''}${remainder}`;
}

// Valida formato 'mm:ss'
export function isValidTime(timeString) {
  return /^[0-9]+:[0-5][0-9]$/.test(timeString);
}

// Alias para mantener compatibilidad
export const formatTimeFromSeconds = formatTime;

// Calcula zonas de velocidad/ritmo a partir del umbral en segundos
export function calculateZonesVP(thresholdSpeedSeconds) {
  const zonas = [
    { name: 'Zona 1', min: thresholdSpeedSeconds * 1.25, max: thresholdSpeedSeconds * 1.15 },
    { name: 'Zona 2', min: thresholdSpeedSeconds * 1.15, max: thresholdSpeedSeconds * 1.05 },
    { name: 'Zona 3', min: thresholdSpeedSeconds * 1.05, max: thresholdSpeedSeconds * 0.95 },
    { name: 'Zona 4', min: thresholdSpeedSeconds * 0.95, max: thresholdSpeedSeconds * 0.85 },
    { name: 'Zona 5', min: thresholdSpeedSeconds * 0.85, max: thresholdSpeedSeconds * 0.75 },
  ];

  return zonas.map((zona) => ({
    ...zona,
    minFormatted: formatTime(zona.min),
    maxFormatted: formatTime(zona.max),
  }));
}

export function calculateSwimmingZones(cssSeconds) {
  const zonas = [
    { name: 'Z1 Recuperación', min: cssSeconds * 1.30, max: cssSeconds * 1.25 },
    { name: 'Z2 Aeróbico',     min: cssSeconds * 1.24, max: cssSeconds * 1.15 },
    { name: 'Z3 Tempo',        min: cssSeconds * 1.14, max: cssSeconds * 1.05 },
    { name: 'Z4 Umbral',       min: cssSeconds * 1.04, max: cssSeconds * 0.96 },
    { name: 'Z5 Velocidad',    min: cssSeconds * 0.95, max: cssSeconds * 0.85 },
    { name: 'Z6 Anaeróbica',   min: cssSeconds * 0.84, max: cssSeconds * 0.70 },
  ];

  return zonas.map((zona) => ({
    ...zona,
    minFormatted: formatTime(zona.min),
    maxFormatted: formatTime(zona.max),
  }));
}


